import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OptionalCookiesDialogComponent } from './optional-cookies-dialog/optional-cookies-dialog.component';
import { WindowService } from '../../service/window.service';
import { CookiesConfigEnum } from '../../enum/cookies-config-enum';
import { ResponsiveService } from '../../service/responsive.service';

@Component({
  selector: 'app-cookies-config',
  templateUrl: './cookies-config.component.html',
  styleUrl: './cookies-config.component.scss'
})
export class CookiesConfigComponent implements OnInit {

  cookiesConfigEnum: typeof CookiesConfigEnum;

  constructor(
    private matDialogRef: MatDialogRef<CookiesConfigComponent>,
    private dialog: MatDialog,
    private windowService: WindowService,
    private responsiveService: ResponsiveService
  ) {
    this.cookiesConfigEnum = CookiesConfigEnum;
  }

  ngOnInit(): void {
  }

  /**
   * Abre el diálogo de las cookies
   */
  openOptionalCookiesDialog(): void {
    this.dialog.open(OptionalCookiesDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      maxWidth: '100%',
      panelClass: 'optionalCookiesDialog',
    }).afterClosed().subscribe((response) => {
      this.matDialogRef.close();
    });
    if (!this.responsiveService.isTablet()) {
      this.matDialogRef.close();
    }
  }

  /**
   * Acepta las cookies seleccioandas y las guarda en localStorage
   * @param response
   */
  acceptCookies(response: CookiesConfigEnum): void {
    const selectedToggles = this.initializeSelectedToggles(response);
    if (this.windowService.isBrowser) {
      localStorage.setItem('selectedCookies', JSON.stringify(selectedToggles));
    }
    this.matDialogRef.close();
  }

  /**
   * Inicializa los selectores de las cookies
   * @param response
   * @returns
   */
  private initializeSelectedToggles(response: CookiesConfigEnum): { [key: string]: boolean } {
    const selectedToggles: { [key: string]: boolean } = {
      ESSENTIAL: true,
      ANALYSIS: false,
      FUNCTIONALITY: false,
      MARKETING: false,
      FRAUD: false,
      SECURITY: false
    };

    switch (response) {
      case CookiesConfigEnum.ALL:
        Object.keys(selectedToggles).forEach(key => selectedToggles[key] = true);
        break;
      case CookiesConfigEnum.ESSENTIAL:
        break;
      default:
        break;
    }

    return selectedToggles;
  }
}
